import { Component, OnInit, Input } from '@angular/core';
import { FileService } from '../../../shared/_services/file.service'

@Component({
  selector: 'app-file-report',
  templateUrl: './file-report.component.html',
  styleUrls: ['./file-report.component.css']
})
export class FileReportComponent implements OnInit {

  totalCount: number;
  correctCount: number;
  incorrectCount: number;
  duplicates: number;

  constructor(private fileService: FileService) { }

  ngOnInit() {
   this.getCountRegisters()
  }

  getCountRegisters() {
    this.fileService.getCountRegisters()
      .subscribe((res:any) => {
        this.totalCount = res.totalCount;
        this.correctCount = res.correctCount;
        this.incorrectCount = res.incorrectCount;
        this.duplicates = res.duplicates;
      });
  }

}
